import { format } from 'date-fns';

import { DateRange } from '@/types';

import { PostgrestDateString } from './postgrest.types';

export const convertToPostgrestDateString = (
  input?: string | Date,
): PostgrestDateString | undefined => {
  try {
    if (!input) return undefined;
    const date = new Date(input);
    return format(date, 'yyyy-MM-dd') as PostgrestDateString;
  } catch {
    return undefined;
  }
};

export const convertToPostgrestDateRange = (
  dateRange: Partial<DateRange>,
): {
  from_date?: PostgrestDateString;
  to_date?: PostgrestDateString;
} => {
  return {
    from_date: convertToPostgrestDateString(dateRange.fromDate),
    to_date: convertToPostgrestDateString(dateRange.toDate),
  };
};

/**
 * Given a vague postgrest date string such as 2025-01-01,
 * which the browser interprets as midnight UTC by default
 * convert to a string which represents midnight in the user's local time
 * so that 2025-01-01 will always remain 2025-01-01 to the user regardless of where they are
 */
export const convertPostgrestDateStringToLocalTime = (
  vagueDateString: string,
) => {
  const date = new Date(vagueDateString);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();

  return new Date(year, month, day).toISOString();
};
